<template>
    <div class="page">
        <div class="cousre-info">
            <div class="title-wrap">
                <p class="title">{{ dataSources.name }}</p>
                <!-- <div>{{ dataSources.status_text }}</div> -->
            </div>
            <div class="info-text">{{ dataSources.start_time }}至{{ dataSources.end_time }}</div>
            <div class="info-text">{{ dataSources.area + dataSources.address }}</div>
            <div class="total">
                <div class="tit td-fsc">
                    <img class="icon" :src="Images.icon_mine_logo3_2" />
                    <span>我的团队小计</span>
                </div>
                <div class="num-box td-fbc">
                    <div>
                        <span>报名学员：</span>
                        <span class="num">{{ statistics.enroll }}</span>
                    </div>
                    <div>
                        <span>签到人数：</span>
                        <span class="num">{{ statistics.sign }}</span>
                    </div>
                    <div>
                        <span>缴费人数：</span>
                        <span class="num">{{ statistics.pay }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="scrollerView">
            <scroller class="scroller" ref="infinite" :on-refresh="refresh" :on-infinite="infinite" :noDataText="listData.length > 1 ? Constants.ALL_LOAD_TIPS : ''">
                <div class="ul">
                    <div class="li" v-for="item in listData" :key="item.id">
                        <div class="flex rcb item-title">
                            <span class="title">{{ item.user_name }}（{{ item.mobile }}）</span>
                            <span class="status" :class="{ blue: item.is_sign == 1 }">{{item.is_sign_text}}</span>
                        </div>
                        <div class="flex rcb item-value">
                            <span class="value">座位费：{{ item.user_payment_sum_text }}元</span>
                            <span class="value">座位：{{ item.user_desk_text }}</span>
                            <span class="value">助教：{{ item.worker_name || '未分配' }} {{ item.worker_mobile }}</span>
                        </div>
                    </div>
                </div>
                <van-empty description="暂无信息～" v-if="listData.length < 1 && !loading" />
            </scroller>
        </div>
    </div>
</template>
<script>
import courseRecordItem from "@/components/item/courseRecordItem";
export default {
    components: {
        courseRecordItem: courseRecordItem,
    },
    data() {
        return {
            dataSources: {},
            statistics: {},
            listData: [],
            page: 1,
            limit: 10,
            loading: true,
        };
    },
    mounted() {
        this.requestData();
    },
    methods: {
        refresh(done) {
            this.requestData();
            setTimeout(() => {
                done();
            }, 1000);
        },
        infinite() {
            this.page++
            setTimeout(() => {
                this.requestData();
            }, 500);
        },
        // 列表数据
        async requestData() {
            let url = this.API.agent_enroll_index;
            let params = {
                id: this.$route.query.id,
                page: this.page,
                limit: this.limit,
            };
            this.loading = true;
            let result = await this.$post(url, params);
            console.log('result---->', result);
            setTimeout(() => this.loading = false, 1000);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data.info;
                this.statistics = result.data.count_num;
                let list = result.data.list.data || []
                if (this.page == 1) {
                    this.listData = list
                } else {
                    this.listData = this.listData.concat(list)
                }
                this.$refs.infinite.finishInfinite(list.length < this.limit);
                console.log('this.dataSources---->', this.dataSources);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

    },
};
</script>
<style lang="less" scoped>
.page {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.scrollerView {
    flex: 1;
    width: 100%;
    position: relative;

    .scroller {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
}

.cousre-info {
    flex-shrink: 0;
    margin: 1rem 1rem;
    padding: 1rem 1rem;
    border-radius: .5rem;
    background: #ffffff;

    .title-wrap {
        display: flex;
        align-items: center;
        margin-bottom: .5rem;

        .title {
            flex: 1;
            color: #333;
            font-weight: 600;
            font-size: 1.6rem;
        }
    }

    .info-text {
        color: #666;
        line-height: 1.5;
        font-size: 1.3rem;
    }

    .total {
        border-top: dashed #eee 1px;
        padding-top: 10px;
        margin-top: 10px;

        .tit {
            font-size: 15px;
            color: #333;
            font-weight: 500;

            .icon {
                width: 16px;
                height: 16px;
                object-fit: contain;
                margin-right: 6px;
            }
        }

        .num-box {
            padding-top: 10px;

            span {
                font-size: 13px;
                color: #333;
            }

            .num {
                font-size: 14px;
                font-weight: 500;
            }
        }
    }

    >p {
        margin-top: 5px;
        font-size: 13px;
        color: #333;
    }
}

.ul {
    padding: 0 1rem;

    .li {
        margin-bottom: 10px;
        background-color: #fff;
        border-radius: 6px;
        padding: 10px;

        .item-title {
            .title {
                color: #333;
                font-size: 14px;
            }

            .status {
                color: #555;
                font-size: 1.2rem;
                background: #ffc107;
                border-radius: 0.3rem;
                padding: 0.2rem 0.7rem;

                &.blue {
                    color: #fff;
                    background: #2196f3;
                }
            }

        }
    }

    .item-value {
        margin-top: 1rem;

        .value {
            color: #666;
            font-size: 1.2rem;
        }
    }

}
</style>